import React from 'react';

const IconButton = ({icon, onClick, className, ariaLabel, color}) => {
  const normalizedIcon = React.isValidElement(icon)
    ? React.cloneElement(icon, {
        style: {
          ...(icon.props.style || {}),
          width: 22,
          height: 22,
          flexShrink: 0,
        },
      })
    : icon;

  return (
    <button
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
      style={{
        width: 32,
        height: 32,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: color || 'var(--color-text-secondary)',
        flexShrink: 0,
      }}>
      {normalizedIcon}
    </button>
  );
};

export default IconButton;
